var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Radar Chart")]),_c('div',{staticClass:"mt-4"},[_c('vue-apex-charts',{attrs:{"type":"radar","height":"300","options":_vm.apexChartData.radarChart.chartOptions,"series":_vm.apexChartData.radarChart.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }